import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ScaleLoader } from 'react-spinners'

const SummaryWidgets = props => {

  const {
    children,
    className,
    borderColor,
    header,
    variant,
    mainText,
    loading,
    ...attributes
  } = props;

  const classes = classNames(
    '', className
  )

  const cardStyle = () => {
    if(variant === '0'){
    return styles.pageCard
   }else if(variant === '1'){
    return styles.pageCardBlue
   } else {
    return styles.pageCardWarning
   } 
  }


  const styles = {
  pageCard: {
    background: 'rgba(255, 255, 255, 0.15)',
    border: '1px solid #F2F2F2',
    backdropFilter: 'blur(10px)'
  },
  pageCardWarning: {
    backdropFilter: 'blur(10px)',
    background: 'rgba(193, 38, 38, 0.15)',
    border: '1px solid #D40B0B'
    },
  pageCardBlue: {
    backdropFilter: 'blur(10px)',
    background: 'rgba(24, 160, 251, 0.15)',
    border: '1px solid #18A0FB'
    },
  pageText: {
    fontFamily: 'Roboto Condensed',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '14px',
    lineHeight: '16px',
    textAlign: 'center',    
    color: '#FFFFFF'
    
  },
  pageHeader: {
    fontFamily: 'Roboto Condensed',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '56px',
    lineHeight: '66px',
    textAlign: 'center',    
    color: '#FFFFFF'
    
  }
}

  return (
    <div className={classes} style={cardStyle()} {...attributes} borderColor={borderColor}>
      {loading?
        <center style={{marginTop: '24px', marginBottom: '24px'}}><ScaleLoader color={'#fff'} loading={loading} /></center>
        :
        <div className="card-body text-center">
        { mainText && <div style={styles.pageText}>{mainText}</div>}
          { header && !children && <div style={styles.pageHeader}>
            {header}</div>}
          {/* { children } */}
        </div>
      }  
    </div>
  )
}

SummaryWidgets.propTypes = {
  children: PropTypes.node,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
  //
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  header: PropTypes.string,
  text: PropTypes.string,
  loading: PropTypes.bool,
};

// SummaryWidgets.propTypes = propTypes;
// SummaryWidgets.defaultProps = defaultProps;

export default SummaryWidgets;


// WEBPACK FOOTER //
// ./src/views/Widgets/SummaryWidgets.jsx